export enum PaymentMethod {
  TravelCard = 'travelcard',
  ToGo = 'togo',
  OtherTicket = 'otherticket',
}
